/** i18n keys for technology keyword tags per expertise slug. */
export const EXPERTISE_TECH_KEYWORDS = {
  'digital-twin': [
    'expertises.tech.digitalTwin.k1',
    'expertises.tech.digitalTwin.k2',
    'expertises.tech.digitalTwin.k3',
    'expertises.tech.digitalTwin.k4',
    'expertises.tech.digitalTwin.k5',
  ],
  blockchain: [
    'expertises.tech.blockchain.k1',
    'expertises.tech.blockchain.k2',
    'expertises.tech.blockchain.k3',
    'expertises.tech.blockchain.k4',
    'expertises.tech.blockchain.k5',
  ],
  observatories: [
    'expertises.tech.observatories.k1',
    'expertises.tech.observatories.k2',
    'expertises.tech.observatories.k3',
    'expertises.tech.observatories.k4',
    'expertises.tech.observatories.k5',
  ],
  'cloud-services': [
    'expertises.tech.cloudServices.k1',
    'expertises.tech.cloudServices.k2',
    'expertises.tech.cloudServices.k3',
    'expertises.tech.cloudServices.k4',
    'expertises.tech.cloudServices.k5',
  ],
  'ecommerce-cms': [
    'expertises.tech.ecommerceCms.k1',
    'expertises.tech.ecommerceCms.k2',
    'expertises.tech.ecommerceCms.k3',
    'expertises.tech.ecommerceCms.k4',
    'expertises.tech.ecommerceCms.k5',
  ],
  'tableau-aide-decision-et-machine-learning': [
    'expertises.tech.decisionDashboard.k1',
    'expertises.tech.decisionDashboard.k2',
    'expertises.tech.decisionDashboard.k3',
    'expertises.tech.decisionDashboard.k4',
    'expertises.tech.decisionDashboard.k5',
    'expertises.tech.decisionDashboard.k6',
  ],
  iot: [
    'expertises.tech.iot.k1',
    'expertises.tech.iot.k2',
    'expertises.tech.iot.k3',
    'expertises.tech.iot.k4',
    'expertises.tech.iot.k5',
  ],
  'data-ia': [
    'expertises.tech.dataIa.k1',
    'expertises.tech.dataIa.k2',
    'expertises.tech.dataIa.k3',
    'expertises.tech.dataIa.k4',
    'expertises.tech.dataIa.k5',
    'expertises.tech.dataIa.k6',
  ],
  'crm-erp': [
    'expertises.tech.crmErp.k1',
    'expertises.tech.crmErp.k2',
    'expertises.tech.crmErp.k3',
    'expertises.tech.crmErp.k4',
    'expertises.tech.crmErp.k5',
  ],
  'gestion-donnees': [
    'expertises.tech.dataManagement.k1',
    'expertises.tech.dataManagement.k2',
    'expertises.tech.dataManagement.k3',
    'expertises.tech.dataManagement.k4',
    'expertises.tech.dataManagement.k5',
  ],
  webmobile: [
    'expertises.tech.webmobile.k1',
    'expertises.tech.webmobile.k2',
    'expertises.tech.webmobile.k3',
    'expertises.tech.webmobile.k4',
    'expertises.tech.webmobile.k5',
    'expertises.tech.webmobile.k6',
  ],
  'e-living-lab': [
    'expertises.tech.eLivingLab.k1',
    'expertises.tech.eLivingLab.k2',
    'expertises.tech.eLivingLab.k3',
    'expertises.tech.eLivingLab.k4',
    'expertises.tech.eLivingLab.k5',
    'expertises.tech.eLivingLab.k6',
  ],
};

export function getTechKeywordsForSlug(slug) {
  return EXPERTISE_TECH_KEYWORDS[slug] || [];
}
